/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptRecommendationAggregateResponse {
    getFixupPrototypeFunction() { return PromptRecommendationAggregateResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptRecommendationAggregateResponse>): PromptRecommendationAggregateResponse {
        let obj = Object.assign(new PromptRecommendationAggregateResponse(), model);
        PromptRecommendationAggregateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptRecommendationAggregateResponse>): PromptRecommendationAggregateResponse {
        if (!model) return null;
        return PromptRecommendationAggregateResponse.newInstance(<PromptRecommendationAggregateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptRecommendationAggregateResponse) {
        if (!obj) return;

        models.PromptRecommendationAggregateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptRecommendationAggregateResponse): boolean {
        Object.setPrototypeOf(obj, PromptRecommendationAggregateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.prompt_recommendations) {
            for (let val of this.prompt_recommendations) {
                models.PromptRecommendationItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Aggregated recommendation items
     */
    prompt_recommendations: Array<models.PromptRecommendationItem>;

}
